export type CheckoutState = {
    sent: boolean;
    combo: {
        valve: string;
        actuator?: string;
        mounted: boolean;
        qty: number;
    };
    accessories: {
        label: string;
        qty: number;
    }[];
};

export type SelectNominalVoltage = '24 V' | '230 V'

export enum SelectValvePosition {
    LM = 'LM',
    LR = 'LR',
    MR = 'MR'
}
